<template>
  <el-dialog v-model="visible" width="520px" append-to-body :show-close="false">
    <div class="container">
      <img :src="imgurl" alt="">
      <p>{{ title }}</p>
      <el-button style="width: 120px;" size="mini" @click="visible = false">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  // 组件名称
  name: 'internalNetwork',
  // 组件参数 接收来自父组件的数据
  props: {
    isView: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'shutdown'
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      visible: false,
      imgurl: 'http://bigdata.topeti.com/PCRepository/middleground/shutdown.png',
      title: '您好，系统只允许内网访问！'
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {
    isView: {
      immediate: true,
      handler(val) {
        if (val) {
          if (this.type === 'shutdown') {
            this.title = '您好，系统只允许内网访问！'
            this.imgurl = 'http://bigdata.topeti.com/PCRepository/middleground/shutdown.png'
          } else {
            this.title = '您好，系统正在停机维护中， 请稍后登录！'
            this.imgurl = 'http://bigdata.topeti.com/PCRepository/middleground/internalNetwork.png'
          }
          this.visible = true
        }
      }
    },
    visible: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.$emit('update:isView', false)
        }
      }
    }
  },
  // 组件方法
  methods: {},
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
    .container {
      height: 400px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 245px;
        height: 220px;
        margin-top: 35px;
        margin-bottom: 28px;
      }
      p {
        color: #333333;
        font-weight: 400;
        font-size: 18px;
        margin-bottom: 32px;
      }
    }
  }
}
</style>
